module.exports = __webpack_public_path__ + "assets/img/a21e-wf.svg";